import React, { JSX, useState } from "react";
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import Panel from "../../components/Panel";
import DoctorAvailabilityChart from "../DashboardV2/ServiceProviderAvailabilityChart/Index";
import useDepartmentSubscription from "../../hooks/useDepartmentSubscription";
import useGetDepartments from "../../hooks/department";
import DepartmentSelect from "../../components/DepartmentSelect";
import { useAppSelector } from "../../store/hooks";
import { ServiceProvider } from "../../interfaces/ServiceProvidersInterface";

interface PanelProps {
  onClose: () => void;
}

const filterSpByDepartment = (departmentId: number, sps: ServiceProvider[]) => {
  if (!departmentId) {
    return sps;
  }
  return sps.filter((sp) => sp.departmentId === departmentId);
};

const DoctorAvailabilityPanel = ({ onClose }: PanelProps): JSX.Element => {
  const { isDepartmentSubscribed } = useDepartmentSubscription();
  const departments = useGetDepartments();

  const [selectedDepartment, setSelectedDepartment] = useState(departments?.[0]?.id || null);

  const serviceProviders = useAppSelector(
    (state) => state.resources.resourceCentreServiceProviders || []
  );

  return (
    <Panel
      wrapperStyle={{ minWidth: "1200px" }}
      titleJsx={
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%"
          }}
        >
          <Typography variant="h6">Doctor Availability</Typography>
          {isDepartmentSubscribed && (
            <DepartmentSelect
              disableClearable={false}
              style={{ width: "300px" }}
              fullWidth
              id={Number(selectedDepartment)}
              onChange={(value) => {
                setSelectedDepartment(value?.id || null);
              }}
            />
          )}
        </Box>
      }
      onClose={onClose}
    >
      <Box pt={2} mr={4}>
        <DoctorAvailabilityChart
          onClose={onClose}
          serviceProviders={filterSpByDepartment(selectedDepartment, serviceProviders)}
        />
      </Box>
    </Panel>
  );
};

export default DoctorAvailabilityPanel;
